import { z } from 'zod'

export const CustomDomainSchema = z.object({
	id: z.string(),
	accountId: z.string(),
	domain: z.string(),
	isVerified: z.boolean(),
	enabled: z.boolean(),
	verificationToken: z.string().nullable(),
	verifiedAt: z.date().nullable().optional(),
	createdAt: z.date(),
	updatedAt: z.date(),
})

export type CustomDomainType = z.infer<typeof CustomDomainSchema>

export const toCustomDomainDto = (data: any): CustomDomainType => {
	return CustomDomainSchema.parse(data)
}

export const toCustomDomainListDto = (data: any[]): CustomDomainType[] => {
	return data.map(toCustomDomainDto)
}

